import { useAsyncRetry } from 'react-use';
import { useBifrostApi } from 'src/services/useBifrostApi';
import { PipelinesApi } from 'src/api-new/bifrost';
import { useInstances } from 'src/components/hooks/useInstances';
import { useContext } from 'react';
import { PipelinesContext } from 'src/domain/pipelines/PipelinesProvider';

export function useAvailableTags() {
  const pipelinesPain = useContext(PipelinesContext);
  const pipelinesApi = useBifrostApi(PipelinesApi);
  const { selectedInstance } = useInstances();

  const availableTags = useAsyncRetry<string[]>(async () => {
    if (!selectedInstance?.id) return [];
    const { data } = await pipelinesApi.getPipelineTags({ instanceId: selectedInstance.id });

    return (data ?? []).filter((tag): tag is string => typeof tag === 'string');
  }, [selectedInstance?.id, pipelinesPain.pipelines]); // changes when instanceId changes

  return availableTags;
}
